// extracted by mini-css-extract-plugin
export default {"title":"ActivitiesStaffTab_title__gi6MX","headerLeftTitleWrap":"ActivitiesStaffTab_headerLeftTitleWrap__9-mf2"};